module.exports = __webpack_public_path__ + "img/order.49ced692.jpg";